import { createAsyncThunk } from "@reduxjs/toolkit";
import PartnerApi from "utility/api";

// eslint-disable-next-line import/prefer-default-export
export const fetchLocalizationsRequest = createAsyncThunk("localization/fetchLocalizationsRequest", async () => {
  const fetchResult = await PartnerApi.getLocalizations();
  return fetchResult.data;
});
